import jwt from "jwt-decode";
import Cookies from 'universal-cookie';

const authTokenKey = "authToken";
const cookies = new Cookies();

type Token = Partial<{
  sub: string;
  iss: string;
  iat: number;
  exp: number;
  aud: string[];
  jti: string;

  realm: string;
  tokenName: string;
  tokenType: string;

  ops: string;
  azp: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  auth_time: string;
  nonce: string;

  firstname: string;
  lastname: string;
  groups: string;
}>;

export function removeToken() {
  cookies.remove(authTokenKey);
}

function isTokenValid(token: Token | null) {
  if (!token?.exp) return false;

  const exp = new Date(token.exp * 1000).valueOf();
  if (!isFinite(exp)) return false;

  const now = new Date().valueOf();
  if (now >= exp) return false;

  return true;
}

export function getTokenString(): string | null {
  const authToken = cookies.get(authTokenKey);
  return authToken;
}

export function getToken(): Token | null {
  const authToken = getTokenString();
  if (!authToken) return null;

  try {
    return jwt<Token>(authToken);
  } catch (err) {
    console.error(err);
  }

  return null;
}

export function getValidToken(): Token | null {
  const token = getToken();
  if (token == null || !isTokenValid(token)) {
    removeToken();
    return null;
  }

  return token;
}

export function hasValidToken() {
  const token = getValidToken();
  return isTokenValid(token);
}

export function setToken(token: string) {
  cookies.set(authTokenKey, token);
}
